var _ellipse, _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsNewDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.12,
    cx: 98.7222,
    cy: 184.333,
    rx: 59.7222,
    ry: 8.33333,
    fill: "#740E81"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 18,
    width: 130,
    height: 130,
    rx: 15,
    fill: "#F6F7F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 36,
    width: 96,
    height: 96,
    rx: 17,
    fill: "url(#paint0_linear_8674_128848)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8674_128848)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.375 49.3125H87.6193L105.107 85.0054L88.7911 118.687H76.5467L92.8335 85.035L75.375 49.3125ZM110.638 49.3125H122.452L113.691 71.018L107.586 56.8532L110.638 49.3125ZM107.954 112.921L113.663 99.0224L122.311 118.687H110.497L107.954 112.921Z",
    fill: "#A614B9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 159.79H56.4534C56.4534 160.395 56.6501 160.887 57.0513 161.277C57.4525 161.667 57.9481 161.865 58.546 161.865C59.1124 161.865 59.5922 161.667 59.9855 161.261C60.371 160.856 60.5677 160.355 60.5677 159.751C60.5677 159.178 60.4182 158.741 60.1193 158.439C59.8204 158.137 59.2618 157.835 58.428 157.517L57.6885 157.238C56.0601 156.634 54.9588 155.982 54.3924 155.275C53.5979 154.281 53.1967 153.12 53.1967 151.784C53.1967 150.242 53.7159 148.938 54.7464 147.865C55.7848 146.791 57.0356 146.259 58.5145 146.259C59.962 146.259 61.197 146.776 62.2197 147.809C63.2423 148.843 63.7694 150.115 63.793 151.633H60.3789C60.3002 150.401 59.6945 149.789 58.5538 149.789C58.0346 149.789 57.5941 149.98 57.2322 150.361C56.8704 150.743 56.6894 151.204 56.6894 151.752C56.6894 152.77 57.3502 153.494 58.6718 153.907L59.8754 154.297C61.1655 154.718 62.1253 155.306 62.7467 156.062C63.6514 157.159 64.1077 158.399 64.1077 159.79C64.1077 161.309 63.5649 162.629 62.4793 163.75C61.3937 164.871 60.1114 165.435 58.6404 165.435C57.657 165.435 56.713 165.181 55.8084 164.672C54.9037 164.163 54.2115 163.495 53.7316 162.668C53.2439 161.849 53 160.887 53 159.79Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1357 146.49V166.771C76.1357 168.313 75.8604 169.506 75.3176 170.341C74.232 172.042 72.6508 172.893 70.5819 172.893C69.0322 172.893 67.7185 172.344 66.6407 171.247C65.563 170.15 65.0281 168.798 65.0281 167.208H68.7175C68.8434 168.488 69.4648 169.132 70.5819 169.132C71.5102 169.132 72.0923 168.711 72.3283 167.876C72.407 167.638 72.4463 167.272 72.4463 166.779V163.249C71.6203 164.68 70.4403 165.396 68.9142 165.396C67.4117 165.396 66.271 164.72 65.5001 163.352C65.1933 162.804 65.0359 161.929 65.0359 160.721V150.33C65.0359 149.153 65.4057 148.175 66.1451 147.404C66.8846 146.633 67.8207 146.243 68.9614 146.243C70.3852 146.243 71.5495 146.911 72.4542 148.247V146.482H76.1357V146.49ZM72.4463 159.314V152.214C72.4463 151.506 72.3283 150.997 72.1002 150.687C71.7147 150.163 71.2112 149.9 70.5898 149.9C70.0942 149.9 69.6615 150.075 69.2918 150.433C68.9142 150.783 68.7254 151.379 68.7254 152.214V159.314C68.7254 159.997 68.804 160.466 68.9614 160.729C69.3232 161.357 69.8818 161.667 70.6291 161.667C71.8406 161.667 72.4463 160.888 72.4463 159.314Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6249 149.392V159.846C83.6249 160.705 83.7822 161.214 84.089 161.373C84.2935 161.476 84.6161 161.532 85.0566 161.532H85.9062V165.094H84.7419C82.8303 165.094 81.4379 164.418 80.5569 163.058C80.1399 162.462 79.9354 161.619 79.9354 160.554V149.392H78.1104V146.458H79.9433V140.781H83.6249V146.458H85.9141V149.392H83.6249Z",
    fill: "#A614B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9091 146.457V148.453C92.1206 147.045 93.7254 146.282 95.7156 146.179V150.058C95.2751 149.955 94.9054 149.899 94.5907 149.899C93.45 149.899 92.4982 150.353 91.7194 151.267C91.1766 151.919 90.9091 152.889 90.9091 154.169V165.093H87.2275V146.457H90.9091Z",
    fill: "#A614B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.81 165.093V163.217C103.008 164.624 101.844 165.331 100.326 165.331C99.4995 165.331 98.7365 165.085 98.0363 164.584C97.3362 164.091 96.8642 163.447 96.6046 162.668C96.4788 162.255 96.408 161.634 96.408 160.823V158.709C96.408 157.015 97.0766 155.664 98.4218 154.678C99.1691 154.129 100.27 153.859 101.718 153.859H103.81V152.253C103.81 151.545 103.692 151.037 103.464 150.726C103.079 150.202 102.583 149.939 101.993 149.939C100.884 149.939 100.263 150.544 100.137 151.744H96.4158C96.4709 150.178 97.0216 148.866 98.0835 147.809C99.1455 146.751 100.444 146.227 101.993 146.227C103.488 146.227 104.786 146.767 105.871 147.848C106.957 148.93 107.5 150.234 107.5 151.744V165.101H103.81V165.093ZM103.81 156.912H102.418C100.892 156.912 100.129 157.5 100.129 158.677V159.575C100.129 160.935 100.758 161.611 102.025 161.611C102.615 161.611 103.087 161.388 103.417 160.943C103.677 160.601 103.803 159.861 103.803 158.709V156.912H103.81Z",
    fill: "#A614B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.071 139V165.157H116.381V163.233C115.524 164.68 114.36 165.395 112.889 165.395C111.646 165.395 110.623 164.886 109.821 163.869C109.278 163.161 109.002 162 109.002 160.379V150.297C109.002 149.145 109.38 148.183 110.127 147.411C110.875 146.64 111.811 146.251 112.92 146.251C114.423 146.251 115.571 146.919 116.373 148.254V139H120.071ZM116.381 159.162V152.452C116.381 151.585 116.24 150.997 115.957 150.687C115.618 150.218 115.138 149.979 114.517 149.979C113.793 149.979 113.25 150.305 112.889 150.957C112.763 151.196 112.692 151.689 112.692 152.444V159.154C112.692 160.068 112.849 160.697 113.156 161.038C113.518 161.46 113.982 161.667 114.556 161.667C115.02 161.667 115.445 161.492 115.815 161.134C116.192 160.784 116.381 160.124 116.381 159.162Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.31 157.159V159.083C125.31 160.021 125.475 160.689 125.813 161.086C126.152 161.476 126.592 161.674 127.135 161.674C128.22 161.674 128.842 161.03 128.999 159.75H132.689C132.689 161.293 132.154 162.621 131.076 163.734C129.998 164.847 128.7 165.403 127.174 165.403C126.191 165.403 125.255 165.133 124.358 164.6C123.469 164.068 122.785 163.352 122.32 162.462C121.856 161.571 121.62 160.45 121.62 159.091V152.031C121.62 150.433 122.163 149.073 123.249 147.952C124.334 146.831 125.64 146.267 127.166 146.267C128.747 146.267 130.061 146.815 131.107 147.912C132.154 149.009 132.681 150.385 132.681 152.031V157.167H125.31V157.159ZM128.991 154.137V152.253C128.991 150.735 128.386 149.979 127.166 149.979C126.466 149.979 125.923 150.289 125.538 150.918C125.381 151.18 125.302 151.625 125.302 152.253V154.137H128.991Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145 165.096H141.682L140.825 163.06L142.54 159.234L145 165.096ZM135.96 165.096H132.642L137.372 155.449L132.959 146.361H136.277L140.698 155.457L135.96 165.096ZM142.532 151.672L140.928 147.919L141.643 146.361H144.96L142.532 151.672Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8674_128848",
    x: 75.375,
    y: 49.3125,
    width: 47.0771,
    height: 73.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.349928 0 0 0 0 0.00649548 0 0 0 0 0.294979 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8674_128848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8674_128848",
    x1: 99,
    y1: 36,
    x2: 99,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CEFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNewDefault);
export default __webpack_public_path__ + "static/media/whats-new-default.b3a675f1d97fbceaefb60e195241e0f1.svg";
export { ForwardRef as ReactComponent };